import api from "../client"
import { OrderCopyResponseData } from "../types/order"

export const orderCopyRequest = async (uuid: string | undefined) => {
  const { data } = await api.post<OrderCopyResponseData>(`/orders/${uuid}/copy`)

  return data
}
